const LOGIC_TEST_IRT_BASE_URL = '/logic-test-irt';

export const LOGIC_TEST_IRT_LINKS = {
    tutorial: () => `${LOGIC_TEST_IRT_BASE_URL}/tutorial`,
    startTest: () => `${LOGIC_TEST_IRT_BASE_URL}/start`,
    test: (testId: string) => `${LOGIC_TEST_IRT_BASE_URL}/${testId}/test`,
    report: (testId?: string) => `${LOGIC_TEST_IRT_BASE_URL}/${testId}/report`,
    fullReport: (testId: string) => `${LOGIC_TEST_IRT_BASE_URL}/${testId}/full-report`
};
